import { render, staticRenderFns } from "./MovingToFormStep.vue?vue&type=template&id=7f5da281"
import script from "./MovingToFormStep.vue?vue&type=script&lang=js"
export * from "./MovingToFormStep.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports